/* ==========================================================================
   Trypooh — Custom Header JS
   Mobile drawer + keyboard-accessible desktop dropdowns
   Vanilla JS only, no dependencies.
   ========================================================================== */

(function () {
  'use strict';

  // -------------------------------------------------------------------------
  // Mobile drawer
  // -------------------------------------------------------------------------

  var hamburger = document.querySelector('.header-hamburger');
  var drawer = document.getElementById('nav-drawer');
  var overlay = document.querySelector('.nav-overlay');
  var drawerClose = document.querySelector('.nav-drawer__close');

  if (hamburger && drawer && overlay) {

    function openDrawer() {
      drawer.removeAttribute('inert');
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Move focus to close button inside drawer
      if (drawerClose) {
        drawerClose.focus();
      }
    }

    function closeDrawer() {
      drawer.setAttribute('inert', '');
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      // Return focus to hamburger
      hamburger.focus();
    }

    hamburger.addEventListener('click', function () {
      var isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    overlay.addEventListener('click', closeDrawer);

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hamburger.getAttribute('aria-expanded') === 'true') {
        closeDrawer();
      }
    });

    // Focus trap inside drawer
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      var focusable = drawer.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        // Shift+Tab: wrap from first to last
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab: wrap from last to first
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  // -------------------------------------------------------------------------
  // Desktop dropdown — keyboard support
  // Each dropdown trigger gets aria-expanded toggled on Enter/Space/arrows.
  // Mouse hover is handled entirely in CSS (no JS needed for that path).
  // -------------------------------------------------------------------------

  var triggers = document.querySelectorAll('.header-nav__trigger');

  function closeAllDropdowns(except) {
    triggers.forEach(function (t) {
      if (t !== except) {
        t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  triggers.forEach(function (trigger) {
    var dropdown = trigger.nextElementSibling; // .header-nav__dropdown

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(trigger);
      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    // Arrow Down: open dropdown and focus first item
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        trigger.setAttribute('aria-expanded', 'true');
        if (dropdown) {
          var firstLink = dropdown.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      }
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Keyboard nav within dropdown
    if (dropdown) {
      dropdown.addEventListener('keydown', function (e) {
        var links = Array.from(dropdown.querySelectorAll('a'));
        var idx = links.indexOf(document.activeElement);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = links[idx + 1] || links[0];
          next.focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = links[idx - 1] || links[links.length - 1];
          prev.focus();
        }
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
        if (e.key === 'Tab') {
          // Close dropdown when tabbing out
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    var inNav = e.target.closest('.header-nav__item');
    if (!inNav) {
      closeAllDropdowns(null);
    }
  });

})();
